/* eslint-disable */
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import Breadcrumb from '../../components/core/breadcrumb'
import PageTitle from '../../components/core/pageTitle'
import Useful from '../../components/pages/useful'
import { Info } from '../../icons'
import { GeneralInput } from '../../components/core/input'
import img1 from '../../assets/images/magazine/1.png'
import img2 from '../../assets/images/magazine/2.png'
import { Button } from '../../components/core/button'
import Slider from './Slider'
import Subscribe from '../../components/pages/subscribe'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import subscribeAPI from '../../api/subscribe'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'

const Magazine = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [data, setData] = useState([])
  const [info, setInfo] = useState([])
  useEffect(() => {
    (async () => {

    const { data } = await PagesAPI.getMagazinePage()
    const data1 = await PagesAPI.getMagazinePageInfo()
    await setData(data)
    await setInfo(data1.data)
    await setLoad(true)
  
    })();
  }, [])
  const crumbs = [
    {
      link: '/',
      text: {
        AZ: 'Ana Səhifə',
        ENG: 'Home',
        RU: 'Главная страница',
        TR: 'Ana Sayfa',
      },
    },
    {
      link: '#',
      text: {
        AZ: 'Jurnal',
        ENG: 'Magazine',
        RU: 'Журнал',
        TR: 'Dergi',
      },
    },
  ]
  const help = {
    AZ:
      'Məqalənizi jurnalımızda dərc etmək üçün bizimlə əlaqə saxlaya bilərsiniz',
    ENG: 'You can contact us to publish your article in our magazine',
    RU:
      'Вы можете связаться с нами, чтобы опубликовать вашу статью в нашем журнале',
    TR:
      'Makalenizi dergimizde yayınlatmak için bizimle iletişime geçebilirsiniz',
  }
  const question = {
    AZ: 'Jurnalımıza abunə olmaq istəyirsiniz?',
    ENG: 'Do you want to subscribe to our magazine?',
    RU: 'Хотите подписаться на наш журнал?',
    TR: 'Dergimize abone olmak ister misiniz?',
  }
  const title1 = {
    AZ: 'Yeni buraxılış',
    ENG: 'New issue',
    RU: 'Новый выпуск',
    TR: 'Yeni sayı',
  }
  const title2 = {
    AZ: 'Keçmiş buraxılış',
    ENG: 'Past issue',
    RU: 'Прошлый выпуск',
    TR: 'Önceki sayılar',
  }
  const data1 = [
    {
      id: 1,
      image: img1,
      label: 'New',
      title: 'Magazine 1st issue: Internet marketing',
    },
  ]
  const data2 = [
    {
      id: 1,
      image: img1,
      title: 'Magazine 1st issue: Internet marketing',
    },
    {
      id: 2,
      image: img2,
      label: 'Top seller',
      title: 'Magazine 1st issue: Internet marketing',
    },
    {
      id: 3,
      image: img1,
      title: 'Magazine 1st issue: Internet marketing',
    },
    {
      id: 4,
      image: img1,
      title: 'Magazine 1st issue: Internet marketing',
    },
    {
      id: 5,
      image: img1,
      title: 'Magazine 1st issue: Internet marketing',
    },
    {
      id: 6,
      image: img2,
      title: 'Magazine 1st issue: Internet marketing',
    },
    {
      id: 7,
      image: img1,
      title: 'Magazine 1st issue: Internet marketing',
    },
    {
      id: 8,
      image: img2,
      title: 'Magazine 1st issue: Internet marketing',
    },
  ]
  const email = {
    ENG: 'Enter your phone number or E-mail address',
    AZ: 'Telefon nömrəniz və ya e-poçt ünvanınız',
    RU: 'Номер телефона или адрес электронной почты',
    TR: 'Telefon numaranız veya e-posta adresiniz',
  }
  const sendAppeal = async (e) => {
    const email = document.querySelector('#subscribe-magazine').value.trim()
    if (email === '') {
      alert(translate.alert?.[language] || translate.alert.AZ)
      return
    }

    const formData = {
      email,
    }
    const data = await subscribeAPI.insert(formData)
    if (data.status === 200) {
      alert(translate.alert_form?.[language] || translate.alert_form.AZ)
      document.querySelector('#subscribe-magazine').value = ''
    }
  }
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <Useful search={false} />
      <div className={`${styles.content}`}>
        <Breadcrumb crumbs={crumbs} />
        <PageTitle>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}</PageTitle>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? data?.description_az
                : language === 'TR'
                ? (data?.description_tr || data?.description_az)
                : language === 'ENG'
                ? data?.description_eng
                : (data?.description_ru || data?.description_az),
          }}
        />
        <p className={styles.info}>
          <Info />
          {help[language] || help.TR || help.AZ}
        </p>
        <div className={styles.subscribe}>
          <p>{question[language]}</p>
          <div>
            <GeneralInput
              id="subscribe-magazine"
              type={'text'}
              placeholder={email[language]}
            />
            <Button
              click={() => {
                sendAppeal()
              }}
              to={'#'}
            >
              {translate.subscribe[language]}
            </Button>
          </div>
        </div>
        <Slider data={data1} title={title1[language]} len={data1.length} />
        <Slider data={data2} title={title2[language]} len={data2.length} />
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Magazine
